// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menuActionOption{
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
.compactAction{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

}
.compactAction:hover .tooltip-btn-txt {
  visibility: visible;
  opacity: 1;
}

.tooltip-btn-txt {
 visibility: hidden;
  width: 200px;
  background-color: #555555cb;
  color: var(--white-color);
  border: 1px solid #373737;
  box-shadow: 3px 3px 6px rgba(87, 0, 0, 0.445);
  text-align: left;
  padding: 10px;
  border-radius: 5px;
  position: absolute;
  z-index: 20;
  transform: translateX(-10%);
  opacity: 0;
  transition: opacity 0.3s;
  font-size: var(--font-size-small);
  overflow-y: 'auto';
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  max-height: 100%;
  overflow: auto;
  top: 100%;
}
/*  */
/*********************************************/

/* .buttonAction {
    position: relative;
    border-radius: 4px;
    font-weight: bold;
    font-size: 11px;
    text-transform: uppercase;
    width: 100%;
height: 100%;
    letter-spacing: 2px;
    background: #1976D2;
    
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    -webkit-transition: all 0.2s ease-in;
    -moz-transition: all 0.2s ease-in;
    transition: all 0.2s ease-in;
  } */
  .actDisabled{
    color: #bdbdbd !important;
    border: 1px solid #bdbdbd !important;
    background: transparent;
    pointer-events: none;
  }
  .actGeneral{
    color: #004e94;
    border: 1px solid rgb(61, 106, 255);
  }
  .actLogin{
    font-size: 14px;
    font-size: 14px;
    background: #003757;
    color: #ffffff;
    border-radius: 5px;
    height: 5vh;
    width: 20vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
  }
  .actGreen{
    font-size: 14px;
    font-size: 14px;
    background: #00aa33;
    color: #ffffff;
    border-radius: 5px;
    height: 4vh;
    width: 20vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
  }
  .actLogin.actDisabled{
    font-size: 14px;
    font-size: 14px;
    background: #979797;
    color: #ffffff;
    border-radius: 5px;
    height: 5vh;
    width: 20vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
  }
  .actGreen.actDisabled{
    font-size: 14px;
    font-size: 14px;
    background: #979797;
    color: #ffffff;
    border-radius: 5px;
    height: 4vh;
    width: 20vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
  }
  .actRed{
    font-size: var(--font-size-small);
    background: var(--error-color);
    color: #ffffff;
    border-radius: 5px;
    height: 4vh;
    width: 20vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
    font-weight: bold;
  }
  .actRed.actDisabled{
    font-size: var(--font-size-small);
    background: #979797;
    color: #ffffff;
    border-radius: 5px;
    height: 4vh;
    width: 20vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
  }
  .actBlanco{
    font-size: 14px;
    font-size: 14px;
    background: aliceblue;
    color: #003757;
    border-radius: 5px;
    height: 5vh;
    width: 20vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
  }
  .actBlanco.actDisabled{
    font-size: 14px;
    font-size: 14px;
    background: #979797;
    color: #ffffff;
    border-radius: 5px;
    height: 5vh;
    width: 20vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
  }
  .actAzul{
    
    font-size: var(--font-size-small);
    font-weight: bold;
    background: var(--second-color);
    color: var(--white-color);
    border-radius: 5px;
    height: auto;
    min-height: 4vh;
    width: 20vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
    
  }
  
  .actAzul.actDisabled{
    font-size: var(--font-size-small);
    background: #979797;
    color: #ffffff;
    border-radius: 5px;
    height: 4vh;
    width: 20vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
  }

  .actFiltro{
    
    font-size: var(--font-size-small);
    font-weight: bold;
    background: rgb(133, 133, 133);
    color: var(--white-color);
    border-radius: 5px;
    height: auto;
    min-height: 4vh;
    width: 13vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
    display: flex;
    align-items: center;
  }
  
  .actFiltro.actDisabled{
    font-size: var(--font-size-small);
    background: #979797;
    color: #ffffff;
    border-radius: 5px;
    height: 4vh;
    width: 15vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
    display: flex;
    align-items: center;
  }
  .actCielo{
   
    font-size: var(--font-size-small);
    font-weight: bold;
    background: var(--forth-color);
    color: var(--white-color);
    border-radius: 5px;
    height: 4vh;
    width: 20vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
  }
  
  .actCielo.actDisabled{
    font-size: var(--font-size-small);
    background: #979797;
    color: #ffffff;
    border-radius: 5px;
    height: 4vh;
    width: 20vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
  }
  .actCancelar{
    font-size: var(--font-size-small);
    font-weight: bold;
    background: var(--cancel-color);
    color: var(--txt-color);
    border: 1px solid var(--second-color);
    border-radius: 5px;
    height: 4vh;
    width: 20vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
  }
  .actCancelar.actDisabled{
    font-size: var(--font-size-small);
    background: #979797;
    color: #ffffff;
    border-radius: 5px;
    height: 4vh;
    width: 20vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
  }
  .actAlert{
    letter-spacing: 1px;
    color: #940000;
    border: 1px solid rgb(255, 61, 61);
  }
  .buttonAction:hover {
    background: #e5f3ff;
    transition: all 0.2s ease-out;
    box-shadow: 0 0 5px 3px #cfcfcf;
    cursor: pointer;
    box-shadow: 0 0 6px 2px rgba(117, 117, 117, 0.815);
    border: 1px solid rgb(46, 46, 46);
    color: #8f8f8f;
  }
  .actGeneral:hover{
    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */
    border: 1px solid rgb(61, 106, 255);
    color: #004e94;
  }
  .actLogin:hover{
    transition: all 0.2s ease-out;
   box-shadow: 0 0 5px 3px #cfcfcf;
    cursor: pointer;
    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */
    /* border: 1px solid rgb(61, 106, 255);
    color: #003757; */
  }
  .actGreen:hover{
    transition: all 0.2s ease-out;
   box-shadow: 0 0 5px 3px #cfcfcf;
    cursor: pointer;
    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */
    /* border: 1px solid rgb(61, 106, 255);
    color: #003757; */
  }
  .actRed:hover{
    transition: all 0.2s ease-out;
    box-shadow: 0 0 5px 3px #cfcfcf;
    cursor: pointer;
    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */
    /* border: 1px solid rgb(61, 106, 255);
    color: #003757; */
  }
  .actBlanco:hover{
    transition: all 0.2s ease-out;
    box-shadow: 0 0 5px 3px #cfcfcf;
    cursor: pointer;
    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */
    /* border: 1px solid rgb(61, 106, 255);
    color: #003757; */
  }
  .actAzul:hover{
    transition: all 0.2s ease-out;
      /* transform: scale(1.1) translateY(-1px); */
      box-shadow: 0 0 5px 3px #cfcfcf;
    cursor: pointer;
    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */
    /* border: 1px solid rgb(61, 106, 255);
    color: #003757; */
  }
  .actFiltro:hover{
    transition: all 0.2s ease-out;
      /* transform: scale(1.1) translateY(-1px); */
    box-shadow: 0 0 5px 3px #cfcfcf;
    cursor: pointer;
    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */
    /* border: 1px solid rgb(61, 106, 255);
    color: #003757; */
  }
  .actCielo:hover{
    transition: all 0.2s ease-out;
    /* transform: scale(1.1) translateY(-1px); */
    box-shadow: 0 0 5px 3px #cfcfcf;
    cursor: pointer;
    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */
    /* border: 1px solid rgb(61, 106, 255);
    color: #003757; */
  }
  .actCancelar:hover{
    transition: all 0.2s ease-out;
   box-shadow: 0 0 5px 3px #cfcfcf;
    cursor: pointer;
    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */
    /* border: 1px solid rgb(61, 106, 255);
    color: #003757; */
  }
  .actAlert:hover{
    /* box-shadow: 0 0 6px 2px rgba(236, 0, 0, 0.815); */
    border: 1px solid rgb(255, 61, 61);
    color: #940000;
  }
  .actLogin:hover::before {
    animation: sh02 0.5s 0s linear;
  }
  /* .actGreen:hover::before {
    -webkit-animation: sh02 0.5s 0s linear;
    -moz-animation: sh02 0.5s 0s linear;
    animation: sh02 0.5s 0s linear;
  } */
  /* .actRed:hover::before {
    -webkit-animation: sh02 0.5s 0s linear;
    -moz-animation: sh02 0.5s 0s linear;
    animation: sh02 0.5s 0s linear;
  } */
  .actBlanco:hover::before {
    animation: sh02 0.5s 0s linear;
  }
  /* .actCancelar:hover::before {
    -webkit-animation: sh02 0.5s 0s linear;
    -moz-animation: sh02 0.5s 0s linear;
    animation: sh02 0.5s 0s linear;
  }
   */
  
  .actLogin::before {
    content: '';
    display: block;
    width: 0px;
    height: 86%;
    position: absolute;
    top: 7%;
    left: 0%;
    opacity: 0;
    color: #fff;
    background: #003757;
    box-shadow: 0 0 50px 30px #fff;
    transform: skewX(-20deg);
  }
  .actGreen::before {
    content: '';
    display: block;
    width: 0px;
    height: 86%;
    position: absolute;
    top: 7%;
    left: 0%;
    opacity: 0;
    color: #fff;
    background: #00aa33;
    box-shadow: 0 0 50px 30px #fff;
    transform: skewX(-20deg);
  }
  .actRed::before {
    content: '';
    display: block;
    width: 0px;
    height: 86%;
    position: absolute;
    top: 7%;
    left: 0%;
    opacity: 0;
    color: #fff;
    background: rgb(235, 42, 42);
    box-shadow: 0 0 50px 30px #fff;
    transform: skewX(-20deg);
  }
  .actBlanco::before {
    content: '';
    display: block;
    width: 0px;
    height: 86%;
    position: absolute;
    top: 7%;
    left: 0%;
    opacity: 0;
    color: #003757;
    background: #e8e8e8;
    box-shadow: 0 0 50px 30px #fff;
    transform: skewX(-20deg);
  }
  .actCancelar::before {
    content: '';
    display: block;
    width: 0px;
    height: 86%;
    position: absolute;
    top: 7%;
    left: 0%;
    opacity: 0;
    color: rgb(235, 42, 42);
    background: #fff;
    box-shadow: 0 0 50px 30px #fff;
    transform: skewX(-20deg);
  }
  /* .buttonAction:hover::before {
    -webkit-animation: sh02 0.5s 0s linear;
    -moz-animation: sh02 0.5s 0s linear;
    animation: sh02 0.5s 0s linear;
  }
  
  .buttonAction::before {
    content: '';
    display: block;
    width: 0px;
    height: 86%;
    position: absolute;
    top: 7%;
    left: 0%;
    opacity: 0;
    background: #fff;
    box-shadow: 0 0 50px 30px #fff;
    -webkit-transform: skewX(-20deg);
    -moz-transform: skewX(-20deg);
    -ms-transform: skewX(-20deg);
    -o-transform: skewX(-20deg);
    transform: skewX(-20deg);
  }
   */
  @keyframes sh02 {
    from {
      opacity: 0;
      left: 0%;
    }
  
    50% {
      opacity: 1;
    }
  
    to {
      opacity: 0;
      left: 100%;
    }
  }
  
  /* .buttonAction:active {
    box-shadow: 0 0 0 0 transparent;
    -webkit-transition: box-shadow 0.2s ease-in;
    -moz-transition: box-shadow 0.2s ease-in;
    transition: box-shadow 0.2s ease-in;
    transform: scale(1) translateY(-1px);
  } */
  /* **************************** horizontal Movil****************************** */
@media  (min-width: 500px) and (max-width: 900px) {
  .actAzul{
    width: 25vh;

  } 
  .actFiltro{
    width: 25vh;

  } 
}

/* ****************************Movil****************************** */
@media (max-width: 500px) {
  
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Action.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;;AAEhB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;CACC,kBAAkB;EACjB,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,UAAU;EACV,wBAAwB;EACxB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA,KAAK;AACL,8CAA8C;;AAE9C;;;;;;;;;;;;;;;;KAgBK;EACH;IACE,yBAAyB;IACzB,oCAAoC;IACpC,uBAAuB;IACvB,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,mCAAmC;EACrC;EACA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAG/B,4BAA4B;EAC9B;EACA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAG/B,4BAA4B;EAC9B;EACA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAG/B,4BAA4B;EAC9B;EACA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAG/B,4BAA4B;EAC9B;EACA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAG/B,4BAA4B;IAC5B,iBAAiB;EACnB;EACA;IACE,iCAAiC;IACjC,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAG/B,4BAA4B;EAC9B;EACA;IACE,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAG/B,4BAA4B;EAC9B;EACA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAG/B,4BAA4B;EAC9B;EACA;;IAEE,iCAAiC;IACjC,iBAAiB;IACjB,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAG/B,4BAA4B;;EAE9B;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAG/B,4BAA4B;EAC9B;;EAEA;;IAEE,iCAAiC;IACjC,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAG/B,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAG/B,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;EACrB;EACA;;IAEE,iCAAiC;IACjC,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAG/B,4BAA4B;EAC9B;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAG/B,4BAA4B;EAC9B;EACA;IACE,iCAAiC;IACjC,iBAAiB;IACjB,+BAA+B;IAC/B,uBAAuB;IACvB,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAG/B,4BAA4B;EAC9B;EACA;IACE,iCAAiC;IACjC,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAG/B,4BAA4B;EAC9B;EACA;IACE,mBAAmB;IACnB,cAAc;IACd,kCAAkC;EACpC;EACA;IACE,mBAAmB;IAGnB,6BAA6B;IAC7B,+BAA+B;IAC/B,eAAe;IACf,kDAAkD;IAClD,iCAAiC;IACjC,cAAc;EAChB;EACA;IACE,sDAAsD;IACtD,mCAAmC;IACnC,cAAc;EAChB;EACA;IAGE,6BAA6B;GAC9B,+BAA+B;IAC9B,eAAe;IACf,sDAAsD;IACtD;qBACiB;EACnB;EACA;IAGE,6BAA6B;GAC9B,+BAA+B;IAC9B,eAAe;IACf,sDAAsD;IACtD;qBACiB;EACnB;EACA;IAGE,6BAA6B;IAC7B,+BAA+B;IAC/B,eAAe;IACf,sDAAsD;IACtD;qBACiB;EACnB;EACA;IAGE,6BAA6B;IAC7B,+BAA+B;IAC/B,eAAe;IACf,sDAAsD;IACtD;qBACiB;EACnB;EACA;IAGE,6BAA6B;MAC3B,4CAA4C;MAC5C,+BAA+B;IACjC,eAAe;IACf,sDAAsD;IACtD;qBACiB;EACnB;EACA;IAGE,6BAA6B;MAC3B,4CAA4C;IAC9C,+BAA+B;IAC/B,eAAe;IACf,sDAAsD;IACtD;qBACiB;EACnB;EACA;IAGE,6BAA6B;IAC7B,4CAA4C;IAC5C,+BAA+B;IAC/B,eAAe;IACf,sDAAsD;IACtD;qBACiB;EACnB;EACA;IAGE,6BAA6B;GAC9B,+BAA+B;IAC9B,eAAe;IACf,sDAAsD;IACtD;qBACiB;EACnB;EACA;IACE,oDAAoD;IACpD,kCAAkC;IAClC,cAAc;EAChB;EACA;IAGE,8BAA8B;EAChC;EACA;;;;KAIG;EACH;;;;KAIG;EACH;IAGE,8BAA8B;EAChC;EACA;;;;;IAKE;;EAEF;IACE,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAK9B,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAK9B,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,WAAW;IACX,4BAA4B;IAC5B,8BAA8B;IAK9B,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,8BAA8B;IAK9B,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,uBAAuB;IACvB,gBAAgB;IAChB,8BAA8B;IAK9B,wBAAwB;EAC1B;EACA;;;;;;;;;;;;;;;;;;;;;;;IAuBE;EACF;IACE;MACE,UAAU;MACV,QAAQ;IACV;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;MACV,UAAU;IACZ;EACF;;EAEA;;;;;;KAMG;EACH,gFAAgF;AAClF;EACE;IACE,WAAW;;EAEb;EACA;IACE,WAAW;;EAEb;AACF;;AAEA,oEAAoE;AACpE;;AAEA","sourcesContent":[".menuActionOption{\r\n    display: flex;\r\n    position: relative;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n.compactAction{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n}\r\n.compactAction:hover .tooltip-btn-txt {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n.tooltip-btn-txt {\r\n visibility: hidden;\r\n  width: 200px;\r\n  background-color: #555555cb;\r\n  color: var(--white-color);\r\n  border: 1px solid #373737;\r\n  box-shadow: 3px 3px 6px rgba(87, 0, 0, 0.445);\r\n  text-align: left;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  position: absolute;\r\n  z-index: 20;\r\n  transform: translateX(-10%);\r\n  opacity: 0;\r\n  transition: opacity 0.3s;\r\n  font-size: var(--font-size-small);\r\n  overflow-y: 'auto';\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  max-height: 100%;\r\n  overflow: auto;\r\n  top: 100%;\r\n}\r\n/*  */\r\n/*********************************************/\r\n\r\n/* .buttonAction {\r\n    position: relative;\r\n    border-radius: 4px;\r\n    font-weight: bold;\r\n    font-size: 11px;\r\n    text-transform: uppercase;\r\n    width: 100%;\r\nheight: 100%;\r\n    letter-spacing: 2px;\r\n    background: #1976D2;\r\n    \r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n  } */\r\n  .actDisabled{\r\n    color: #bdbdbd !important;\r\n    border: 1px solid #bdbdbd !important;\r\n    background: transparent;\r\n    pointer-events: none;\r\n  }\r\n  .actGeneral{\r\n    color: #004e94;\r\n    border: 1px solid rgb(61, 106, 255);\r\n  }\r\n  .actLogin{\r\n    font-size: 14px;\r\n    font-size: 14px;\r\n    background: #003757;\r\n    color: #ffffff;\r\n    border-radius: 5px;\r\n    height: 5vh;\r\n    width: 20vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n  }\r\n  .actGreen{\r\n    font-size: 14px;\r\n    font-size: 14px;\r\n    background: #00aa33;\r\n    color: #ffffff;\r\n    border-radius: 5px;\r\n    height: 4vh;\r\n    width: 20vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n  }\r\n  .actLogin.actDisabled{\r\n    font-size: 14px;\r\n    font-size: 14px;\r\n    background: #979797;\r\n    color: #ffffff;\r\n    border-radius: 5px;\r\n    height: 5vh;\r\n    width: 20vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n  }\r\n  .actGreen.actDisabled{\r\n    font-size: 14px;\r\n    font-size: 14px;\r\n    background: #979797;\r\n    color: #ffffff;\r\n    border-radius: 5px;\r\n    height: 4vh;\r\n    width: 20vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n  }\r\n  .actRed{\r\n    font-size: var(--font-size-small);\r\n    background: var(--error-color);\r\n    color: #ffffff;\r\n    border-radius: 5px;\r\n    height: 4vh;\r\n    width: 20vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n    font-weight: bold;\r\n  }\r\n  .actRed.actDisabled{\r\n    font-size: var(--font-size-small);\r\n    background: #979797;\r\n    color: #ffffff;\r\n    border-radius: 5px;\r\n    height: 4vh;\r\n    width: 20vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n  }\r\n  .actBlanco{\r\n    font-size: 14px;\r\n    font-size: 14px;\r\n    background: aliceblue;\r\n    color: #003757;\r\n    border-radius: 5px;\r\n    height: 5vh;\r\n    width: 20vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n  }\r\n  .actBlanco.actDisabled{\r\n    font-size: 14px;\r\n    font-size: 14px;\r\n    background: #979797;\r\n    color: #ffffff;\r\n    border-radius: 5px;\r\n    height: 5vh;\r\n    width: 20vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n  }\r\n  .actAzul{\r\n    \r\n    font-size: var(--font-size-small);\r\n    font-weight: bold;\r\n    background: var(--second-color);\r\n    color: var(--white-color);\r\n    border-radius: 5px;\r\n    height: auto;\r\n    min-height: 4vh;\r\n    width: 20vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n    \r\n  }\r\n  \r\n  .actAzul.actDisabled{\r\n    font-size: var(--font-size-small);\r\n    background: #979797;\r\n    color: #ffffff;\r\n    border-radius: 5px;\r\n    height: 4vh;\r\n    width: 20vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n  }\r\n\r\n  .actFiltro{\r\n    \r\n    font-size: var(--font-size-small);\r\n    font-weight: bold;\r\n    background: rgb(133, 133, 133);\r\n    color: var(--white-color);\r\n    border-radius: 5px;\r\n    height: auto;\r\n    min-height: 4vh;\r\n    width: 13vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .actFiltro.actDisabled{\r\n    font-size: var(--font-size-small);\r\n    background: #979797;\r\n    color: #ffffff;\r\n    border-radius: 5px;\r\n    height: 4vh;\r\n    width: 15vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  .actCielo{\r\n   \r\n    font-size: var(--font-size-small);\r\n    font-weight: bold;\r\n    background: var(--forth-color);\r\n    color: var(--white-color);\r\n    border-radius: 5px;\r\n    height: 4vh;\r\n    width: 20vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n  }\r\n  \r\n  .actCielo.actDisabled{\r\n    font-size: var(--font-size-small);\r\n    background: #979797;\r\n    color: #ffffff;\r\n    border-radius: 5px;\r\n    height: 4vh;\r\n    width: 20vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n  }\r\n  .actCancelar{\r\n    font-size: var(--font-size-small);\r\n    font-weight: bold;\r\n    background: var(--cancel-color);\r\n    color: var(--txt-color);\r\n    border: 1px solid var(--second-color);\r\n    border-radius: 5px;\r\n    height: 4vh;\r\n    width: 20vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n  }\r\n  .actCancelar.actDisabled{\r\n    font-size: var(--font-size-small);\r\n    background: #979797;\r\n    color: #ffffff;\r\n    border-radius: 5px;\r\n    height: 4vh;\r\n    width: 20vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: all 0.2s ease-in;\r\n    -moz-transition: all 0.2s ease-in;\r\n    transition: all 0.2s ease-in;\r\n  }\r\n  .actAlert{\r\n    letter-spacing: 1px;\r\n    color: #940000;\r\n    border: 1px solid rgb(255, 61, 61);\r\n  }\r\n  .buttonAction:hover {\r\n    background: #e5f3ff;\r\n    -webkit-transition: all 0.2s ease-out;\r\n    -moz-transition: all 0.2s ease-out;\r\n    transition: all 0.2s ease-out;\r\n    box-shadow: 0 0 5px 3px #cfcfcf;\r\n    cursor: pointer;\r\n    box-shadow: 0 0 6px 2px rgba(117, 117, 117, 0.815);\r\n    border: 1px solid rgb(46, 46, 46);\r\n    color: #8f8f8f;\r\n  }\r\n  .actGeneral:hover{\r\n    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */\r\n    border: 1px solid rgb(61, 106, 255);\r\n    color: #004e94;\r\n  }\r\n  .actLogin:hover{\r\n    -webkit-transition: all 0.2s ease-out;\r\n    -moz-transition: all 0.2s ease-out;\r\n    transition: all 0.2s ease-out;\r\n   box-shadow: 0 0 5px 3px #cfcfcf;\r\n    cursor: pointer;\r\n    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */\r\n    /* border: 1px solid rgb(61, 106, 255);\r\n    color: #003757; */\r\n  }\r\n  .actGreen:hover{\r\n    -webkit-transition: all 0.2s ease-out;\r\n    -moz-transition: all 0.2s ease-out;\r\n    transition: all 0.2s ease-out;\r\n   box-shadow: 0 0 5px 3px #cfcfcf;\r\n    cursor: pointer;\r\n    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */\r\n    /* border: 1px solid rgb(61, 106, 255);\r\n    color: #003757; */\r\n  }\r\n  .actRed:hover{\r\n    -webkit-transition: all 0.2s ease-out;\r\n    -moz-transition: all 0.2s ease-out;\r\n    transition: all 0.2s ease-out;\r\n    box-shadow: 0 0 5px 3px #cfcfcf;\r\n    cursor: pointer;\r\n    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */\r\n    /* border: 1px solid rgb(61, 106, 255);\r\n    color: #003757; */\r\n  }\r\n  .actBlanco:hover{\r\n    -webkit-transition: all 0.2s ease-out;\r\n    -moz-transition: all 0.2s ease-out;\r\n    transition: all 0.2s ease-out;\r\n    box-shadow: 0 0 5px 3px #cfcfcf;\r\n    cursor: pointer;\r\n    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */\r\n    /* border: 1px solid rgb(61, 106, 255);\r\n    color: #003757; */\r\n  }\r\n  .actAzul:hover{\r\n    -webkit-transition: all 0.2s ease-out;\r\n    -moz-transition: all 0.2s ease-out;\r\n    transition: all 0.2s ease-out;\r\n      /* transform: scale(1.1) translateY(-1px); */\r\n      box-shadow: 0 0 5px 3px #cfcfcf;\r\n    cursor: pointer;\r\n    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */\r\n    /* border: 1px solid rgb(61, 106, 255);\r\n    color: #003757; */\r\n  }\r\n  .actFiltro:hover{\r\n    -webkit-transition: all 0.2s ease-out;\r\n    -moz-transition: all 0.2s ease-out;\r\n    transition: all 0.2s ease-out;\r\n      /* transform: scale(1.1) translateY(-1px); */\r\n    box-shadow: 0 0 5px 3px #cfcfcf;\r\n    cursor: pointer;\r\n    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */\r\n    /* border: 1px solid rgb(61, 106, 255);\r\n    color: #003757; */\r\n  }\r\n  .actCielo:hover{\r\n    -webkit-transition: all 0.2s ease-out;\r\n    -moz-transition: all 0.2s ease-out;\r\n    transition: all 0.2s ease-out;\r\n    /* transform: scale(1.1) translateY(-1px); */\r\n    box-shadow: 0 0 5px 3px #cfcfcf;\r\n    cursor: pointer;\r\n    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */\r\n    /* border: 1px solid rgb(61, 106, 255);\r\n    color: #003757; */\r\n  }\r\n  .actCancelar:hover{\r\n    -webkit-transition: all 0.2s ease-out;\r\n    -moz-transition: all 0.2s ease-out;\r\n    transition: all 0.2s ease-out;\r\n   box-shadow: 0 0 5px 3px #cfcfcf;\r\n    cursor: pointer;\r\n    /* box-shadow: 0 0 6px 2px rgba(0, 142, 236, 0.815); */\r\n    /* border: 1px solid rgb(61, 106, 255);\r\n    color: #003757; */\r\n  }\r\n  .actAlert:hover{\r\n    /* box-shadow: 0 0 6px 2px rgba(236, 0, 0, 0.815); */\r\n    border: 1px solid rgb(255, 61, 61);\r\n    color: #940000;\r\n  }\r\n  .actLogin:hover::before {\r\n    -webkit-animation: sh02 0.5s 0s linear;\r\n    -moz-animation: sh02 0.5s 0s linear;\r\n    animation: sh02 0.5s 0s linear;\r\n  }\r\n  /* .actGreen:hover::before {\r\n    -webkit-animation: sh02 0.5s 0s linear;\r\n    -moz-animation: sh02 0.5s 0s linear;\r\n    animation: sh02 0.5s 0s linear;\r\n  } */\r\n  /* .actRed:hover::before {\r\n    -webkit-animation: sh02 0.5s 0s linear;\r\n    -moz-animation: sh02 0.5s 0s linear;\r\n    animation: sh02 0.5s 0s linear;\r\n  } */\r\n  .actBlanco:hover::before {\r\n    -webkit-animation: sh02 0.5s 0s linear;\r\n    -moz-animation: sh02 0.5s 0s linear;\r\n    animation: sh02 0.5s 0s linear;\r\n  }\r\n  /* .actCancelar:hover::before {\r\n    -webkit-animation: sh02 0.5s 0s linear;\r\n    -moz-animation: sh02 0.5s 0s linear;\r\n    animation: sh02 0.5s 0s linear;\r\n  }\r\n   */\r\n  \r\n  .actLogin::before {\r\n    content: '';\r\n    display: block;\r\n    width: 0px;\r\n    height: 86%;\r\n    position: absolute;\r\n    top: 7%;\r\n    left: 0%;\r\n    opacity: 0;\r\n    color: #fff;\r\n    background: #003757;\r\n    box-shadow: 0 0 50px 30px #fff;\r\n    -webkit-transform: skewX(-20deg);\r\n    -moz-transform: skewX(-20deg);\r\n    -ms-transform: skewX(-20deg);\r\n    -o-transform: skewX(-20deg);\r\n    transform: skewX(-20deg);\r\n  }\r\n  .actGreen::before {\r\n    content: '';\r\n    display: block;\r\n    width: 0px;\r\n    height: 86%;\r\n    position: absolute;\r\n    top: 7%;\r\n    left: 0%;\r\n    opacity: 0;\r\n    color: #fff;\r\n    background: #00aa33;\r\n    box-shadow: 0 0 50px 30px #fff;\r\n    -webkit-transform: skewX(-20deg);\r\n    -moz-transform: skewX(-20deg);\r\n    -ms-transform: skewX(-20deg);\r\n    -o-transform: skewX(-20deg);\r\n    transform: skewX(-20deg);\r\n  }\r\n  .actRed::before {\r\n    content: '';\r\n    display: block;\r\n    width: 0px;\r\n    height: 86%;\r\n    position: absolute;\r\n    top: 7%;\r\n    left: 0%;\r\n    opacity: 0;\r\n    color: #fff;\r\n    background: rgb(235, 42, 42);\r\n    box-shadow: 0 0 50px 30px #fff;\r\n    -webkit-transform: skewX(-20deg);\r\n    -moz-transform: skewX(-20deg);\r\n    -ms-transform: skewX(-20deg);\r\n    -o-transform: skewX(-20deg);\r\n    transform: skewX(-20deg);\r\n  }\r\n  .actBlanco::before {\r\n    content: '';\r\n    display: block;\r\n    width: 0px;\r\n    height: 86%;\r\n    position: absolute;\r\n    top: 7%;\r\n    left: 0%;\r\n    opacity: 0;\r\n    color: #003757;\r\n    background: #e8e8e8;\r\n    box-shadow: 0 0 50px 30px #fff;\r\n    -webkit-transform: skewX(-20deg);\r\n    -moz-transform: skewX(-20deg);\r\n    -ms-transform: skewX(-20deg);\r\n    -o-transform: skewX(-20deg);\r\n    transform: skewX(-20deg);\r\n  }\r\n  .actCancelar::before {\r\n    content: '';\r\n    display: block;\r\n    width: 0px;\r\n    height: 86%;\r\n    position: absolute;\r\n    top: 7%;\r\n    left: 0%;\r\n    opacity: 0;\r\n    color: rgb(235, 42, 42);\r\n    background: #fff;\r\n    box-shadow: 0 0 50px 30px #fff;\r\n    -webkit-transform: skewX(-20deg);\r\n    -moz-transform: skewX(-20deg);\r\n    -ms-transform: skewX(-20deg);\r\n    -o-transform: skewX(-20deg);\r\n    transform: skewX(-20deg);\r\n  }\r\n  /* .buttonAction:hover::before {\r\n    -webkit-animation: sh02 0.5s 0s linear;\r\n    -moz-animation: sh02 0.5s 0s linear;\r\n    animation: sh02 0.5s 0s linear;\r\n  }\r\n  \r\n  .buttonAction::before {\r\n    content: '';\r\n    display: block;\r\n    width: 0px;\r\n    height: 86%;\r\n    position: absolute;\r\n    top: 7%;\r\n    left: 0%;\r\n    opacity: 0;\r\n    background: #fff;\r\n    box-shadow: 0 0 50px 30px #fff;\r\n    -webkit-transform: skewX(-20deg);\r\n    -moz-transform: skewX(-20deg);\r\n    -ms-transform: skewX(-20deg);\r\n    -o-transform: skewX(-20deg);\r\n    transform: skewX(-20deg);\r\n  }\r\n   */\r\n  @keyframes sh02 {\r\n    from {\r\n      opacity: 0;\r\n      left: 0%;\r\n    }\r\n  \r\n    50% {\r\n      opacity: 1;\r\n    }\r\n  \r\n    to {\r\n      opacity: 0;\r\n      left: 100%;\r\n    }\r\n  }\r\n  \r\n  /* .buttonAction:active {\r\n    box-shadow: 0 0 0 0 transparent;\r\n    -webkit-transition: box-shadow 0.2s ease-in;\r\n    -moz-transition: box-shadow 0.2s ease-in;\r\n    transition: box-shadow 0.2s ease-in;\r\n    transform: scale(1) translateY(-1px);\r\n  } */\r\n  /* **************************** horizontal Movil****************************** */\r\n@media  (min-width: 500px) and (max-width: 900px) {\r\n  .actAzul{\r\n    width: 25vh;\r\n\r\n  } \r\n  .actFiltro{\r\n    width: 25vh;\r\n\r\n  } \r\n}\r\n\r\n/* ****************************Movil****************************** */\r\n@media (max-width: 500px) {\r\n  \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
